const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer>
            <div className="copy-rights">
                <div>&copy; {year} Laboratory of Nancy Du, PhD.&nbsp;</div>
                <div>All rights reserved.</div>
            </div>
        </footer>
    );
}

export default Footer;